import { addClass, removeClass } from '../support/classes';
import { createElement } from '../support/dom';
import Component from './Component';

class Tabs extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.initialize();
    }

    initialize()
    {
        this.index = 0;
        this.oldIndex = 0;

        if (this.element)
        {
            this.decorate();
        }
        else
        {
            this.render();
        }

        this.bindEvents();

        this.updateIndicator();
    }

    decorate()
    {
        this.indicator = this.element.querySelector('.indicator');

        if (!this.indicator)
        {
            this.renderIndicator();
        }
    }

    render()
    {
        this.element = createElement('ul', null, {
            class: [
                'tabs',
                this.props.className,
            ],
        });

        this.renderTabs();
        this.renderIndicator();

        return this.element;
    }

    renderTabs()
    {
        for (let i = 0; i < this.props.tabs.length; i++)
        {
            this.renderTab(this.props.tabs[i]);
        }
    }

    renderIndicator()
    {
        this.indicator = createElement('li', null, {
            class: 'indicator',
        });

        this.element.appendChild(this.indicator);
    }

    renderTab([value, text])
    {
        const tab = createElement('li', null, {
            class: 'tab',
        });

        tab.appendChild(createElement('a', text, {
            'data-value': value,
        }));

        this.element.appendChild(tab);
    }

    getActiveTab()
    {
        return this.element.children[this.getIndex()];
    }

    getValue()
    {
        return this.getActiveTab().querySelector('a').getAttribute('data-value');
    }

    updateTabs()
    {
        const tabs = this.element.children;

        removeClass(tabs[this.oldIndex], 'active');

        addClass(this.getActiveTab().querySelector('a'), 'active');
    }

    updateIndicator()
    {
        const tab = this.getActiveTab();

        this.indicator.style.left = `${tab.offsetLeft}px`;
        this.indicator.style.width = `${tab.offsetWidth}px`;
    }

    setTab(index)
    {
        if (index !== this.oldIndex)
        {
            this.index = index;

            this.updateTabs();
            this.updateIndicator();

            this.props.onChange && this.props.onChange.call(this, this.getActiveTab(), this.getValue());

            this.oldIndex = this.index;
        }
    }

    getIndex()
    {
        return this.index;
    }
    
    _handleClick = (e) =>
    {
        const target = e.target;

        const tab = target.parentNode;

        if (tab.tagName !== 'LI')
        {
            return;
        }

        for (let i = 0; i < this.element.children.length; i++)
        {
            if (this.element.children[i] === tab)
            {
                this.setTab(i);
            }
        }
        
        e.preventDefault();
    }

    _handleResize = (e) =>
    {
        this.updateIndicator();
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick);
        window.addEventListener('resize', this._handleResize);
    }
    
    unbindEvents()
    {
        this.element.removeEventListener('click', this._handleClick);        
        window.removeEventListener('resize', this._handleResize);
    }

    /**
     * Clears the tabs.
     */
    clear()
    {
        this.empty();
    }

    /**
     * Removes the component.
     */
    remove()
    {
        this.unbindEvents();

        this.empty();

        this.element.parentNode.removeChild(this.element);

        delete this.element;
    }
}

export default Tabs;